import { Box, List, Text } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router'

import type { DeleteBlocker } from '../types/phoneNumber.types'
import type { BlockerRoutePaths } from '../utils/buildBlockerLink'
import { buildBlockerLink } from '../utils/buildBlockerLink'

export interface DeleteBlockersListProps {
  blockers: DeleteBlocker[]
  routePaths: BlockerRoutePaths
}

/**
 * Renders a bulleted list of blockers that prevent phone number deletion.
 * Each entry shows `label: name`; when the resource type has a configured
 * admin3 path, `name` becomes a clickable link to that page.
 */
export const DeleteBlockersList: React.FC<DeleteBlockersListProps> = ({
  blockers,
  routePaths,
}) => {
  return (
    <List.Root gap={1.5} paddingInlineStart={4}>
      {blockers.map((blocker, idx) => {
        const href = buildBlockerLink(blocker, routePaths)
        const nameNode = href ? (
          <Link to={href} style={{ textDecoration: 'underline' }}>
            <Text as="span" color="blue.fg" fontSize="sm">
              {blocker.name}
            </Text>
          </Link>
        ) : (
          <Text as="span" fontSize="sm">
            {blocker.name}
          </Text>
        )

        return (
          <List.Item key={`${blocker.kind}-${blocker.resource_id ?? idx}`}>
            <Box as="span" fontSize="sm">
              <Text as="span" fontWeight="600" fontSize="sm">
                {blocker.label}:
              </Text>{' '}
              {nameNode}
            </Box>
          </List.Item>
        )
      })}
    </List.Root>
  )
}

DeleteBlockersList.displayName = 'DeleteBlockersList'
